/**
 * token 操作封装
 */
import {QRCODE_STORE_NAME} from '@/config/setting';

/**
 * 获取缓存的 token
 */
export function getQrcodeToken() {
    const token = localStorage.getItem(QRCODE_STORE_NAME);
    if (!token) {
        return sessionStorage.getItem(QRCODE_STORE_NAME);
    }
    return token;
}

/**
 * 缓存 token
 * @param token token
 * @param remember 是否永久存储
 */
export function setQrcodeToken(token, remember) {
    removeQrcodeToken();
    if (token) {
        if (remember) {
            localStorage.setItem(QRCODE_STORE_NAME, token);
        } else {
            sessionStorage.setItem(QRCODE_STORE_NAME, token);
        }
    }
}

/**
 * 移除 token
 */
export function removeQrcodeToken() {
    localStorage.removeItem(QRCODE_STORE_NAME);
    sessionStorage.removeItem(QRCODE_STORE_NAME);
}
